export default "__VITE_ASSET__D$S80mB6__"